import React from 'react';
import { CprButton } from 'canopy-styleguide!sofe';
import cancelable from 'react-disposable-decorator'
import { asyncStacktrace, catchSyncStacktrace } from 'auto-trace'
import { doesTokenLookValid } from '../../utilities/checkToken'

import { MobileDesktopWrapper } from 'src/mobile/mobile-wrapper/mobile-wrapper.component.js'
import { allowDevice } from './access-request.resource'
import styles from './access-request.styles.css';

@cancelable
export default class MfaAccessRequest extends React.PureComponent {
  state = {
    badToken: false,
    buttonClicked: false
  }

  render() {
    return (
      <MobileDesktopWrapper
        image="https://cdn.canopytax.com/static/login-ui/devices.svg"
        mobile={this.props.mobile}>
        {this.getContent()}
      </MobileDesktopWrapper>
    );
  }

  getContent() {
    const softTokenCheck = doesTokenLookValid(this.props.mfaToken)
    if(!softTokenCheck.maybeValid) return <div>It appears your token is invalid. Please try again.</div>

    const { mobile, mfaOtherDeviceData: {location, device, time}} = this.props

    return (
      <div>
        <div className={`cps-padding-bottom-16`}>
          Your account is being used to sign into a device {location && <span>near {location}</span>}
        </div>
        { (device || time) &&
          <div className={`cps-padding-bottom-16`}>
            {device && <div>Device: {device}</div>}
            {time && <div>Time & Date: {time}</div>}
          </div>
        }
        <div className={`cps-padding-bottom-16`}>
          <strong>Do you want to authorize the device {device && <span>listed above?</span>}</strong>
        </div>
        <div className={`cps-padding-bottom-16 ${mobile ? styles.mobileWrapper : ''}`}>
          <CprButton
            actionType="primary"
            onClick={() => this.requestClickHandler(true)}
            disabled={ this.state.buttonClicked }
          >
            Allow
          </CprButton>
          <CprButton
            actionType="secondary"
            onClick={() => this.requestClickHandler(false)}
            disabled={ this.state.buttonClicked }
          >
            Don't Allow
          </CprButton>
        </div>
        { this.state.badToken &&
          <div className="cps-warning">
            Your token is bad. Please check the link from your email and try again.
          </div>
        }
      </div>
    )
  }

  requestClickHandler = allow => {
    this.setState({buttonClicked: true})
    const { mfaToken } = this.props
    const softTokenCheck = doesTokenLookValid(mfaToken)

    if(softTokenCheck.maybeValid) {
      this.props.cancelWhenUnmounted(
        allowDevice(allow, mfaToken).subscribe(
          () => {
            const newRoute = `${this.props.match.path}/access-${allow ? 'authorized' : 'denied'}`
            this.props.history.push(newRoute)
          },
          asyncStacktrace(err => {
            if(err.status === 401) {
              this.setState({badToken: true})
            } else {
              catchSyncStacktrace(err)
            }
          })
        )
      )
    } else {
      this.setState({badToken: true})
    }
  }
}
